import React from 'react';
import InlineTextEditor from './InlineTextEditor';

/**
 * 서점에서 가져온 제목은 부제와 홍보 문구가 통째로 붙어 온다.
 * '권력과 진보 - 기술과 번영을 둘러싼 천년의 쟁투, 2024 노벨경제학상 수상작가'
 * 처음 구분자 앞까지만 남긴 것을 제안한다. 자동으로 바꾸지는 않는다 —
 * 쉼표나 붙임표가 제목의 일부인 책도 있기 때문이다.
 */
export const shortenTitle = (title = '') => {
  const head = String(title)
    .split(/\s[-–—:]\s/)[0]   // 앞뒤로 띄어 쓴 구분자만 (스파이더맨-홈커밍 은 남긴다)
    .split(/\s*[(（[]/)[0]     // 괄호로 열리는 덧말
    .split(',')[0];
  return head.trim();
};

/** 책 제목 고치기 — 길게 딸려 온 부제를 직접 다듬는다 */
const TitleEditor = ({ book, onUpdateBook }) => (
  <InlineTextEditor
    label="책 제목"
    editLabel="제목 수정"
    value={book.title}
    display={<p className="font-display text-2xl leading-snug break-words">{book.title}</p>}
    suggestions={[{ label: '부제 빼기', value: shortenTitle(book.title) }]}
    inputClassName="font-display text-lg leading-snug"
    onSave={(title) => onUpdateBook(book.id, { title })}
  />
);

export default TitleEditor;
